<div class="options" fxLayout="row wrap" [fxLayoutAlign]="align">
  <app-card-option *ngFor="let option of options" [checked]="existsValue(option.value)" [option]="option" (changed)="updateValue($event, option.value)"></app-card-option>
</div>
